import { DUAL_STREAM_MIN_BANDWIDTH } from '../const';

/**
 * Determines whether dual-stream should be enabled at join time based on the
 * measured bandwidth and whether the session is starting in audio-only mode.
 *
 * @param {*} bandwidthKbps - Measured bandwidth in kbps
 * @param {*} audioOnly - Whether the session is joining in audio-only mode
 * @returns {boolean}
 */
export function shouldEnableDualStreamOnJoin(bandwidthKbps, audioOnly) {
  if (audioOnly) return false;
  const bw = parseInt(bandwidthKbps, 10);
  if (isNaN(bw) || bw < 0) return false;
  return bw >= DUAL_STREAM_MIN_BANDWIDTH;
}
